module.exports = __webpack_public_path__ + "img/five-bessings-cart.1ed128fe.png";